import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgIcon } from '@ng-icons/core';
import { AvatarComponent } from '../../../../avatar/avatar.component';
import { PopoverComponent } from '../../../../popover/popover.component';
import { PopoverDividerComponent } from '../../../../popover/popover-divider.component';
import { PopoverItemComponent } from '../../../../popover/popover-item.component';
import { QuickPresencePopoverComponent } from '../../../../../../modules/calendar/components/quick-presence-popover/quick-presence-popover.component';
import { QuickInventoryPopoverComponent } from '../../../../../../modules/inventories/components/quick-inventory-popover/quick-inventory-popover.component';
import { QuickTaskPopoverComponent } from '../../../../../../modules/project-management/components/quick-task-popover/quick-task-popover.component';
import { SIDENAV } from '../../sidenav-context';
import type { SidebarMode } from '../../sidenav-v2.component';
import { TooltipDirective } from '../../../../tooltip/tooltip.directive';

/**
 * Sidenav « café inversé » (MOKA-214).
 *
 * Rail café foncé et texte crème dans les deux thèmes. Les modules sont
 * repérés par un carré de leur couleur ; le module actif devient une pilule
 * crème. Projets déplie ses dossiers favoris et ses projets ; les autres
 * modules gardent leur navigation dans l'en-tête. Une carte invite à parler à
 * l'assistant quand le module est souscrit.
 *
 * Toute la logique vient du contrôleur SidenavV2Component (jeton SIDENAV).
 */
@Component({
  selector: 'app-sidenav-cafe',
  imports: [
    NgIcon,
    RouterLink,
    RouterLinkActive,
    TooltipDirective,
    NgTemplateOutlet,
    AvatarComponent,
    PopoverComponent,
    PopoverItemComponent,
    PopoverDividerComponent,
    QuickPresencePopoverComponent,
    QuickInventoryPopoverComponent,
    QuickTaskPopoverComponent,
  ],
  templateUrl: './sidenav-cafe.component.html',
  styleUrls: ['../../sidenav-rail.scss', './sidenav-cafe.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavCafeComponent {
  readonly mode = input.required<SidebarMode>();
  readonly isMobile = input.required<boolean>();

  protected readonly nav = inject(SIDENAV);

  protected readonly fullName = computed(() => {
    this.nav.authService.profileRevision();
    const p = this.nav.authService.profile;
    return `${p?.['first_name'] ?? ''} ${p?.['last_name'] ?? ''}`.trim();
  });

}
